import React from 'react';
import { observer } from 'mobx-react';
import { Button } from 'antd';

@observer
export default class ButtonNew extends React.Component<any, any>{

    onClick = () => {
        const { onClick, id } = this.props;
        onClick(id);
    }

    render() {
        const { type='ghost', content ,disabled=false} = this.props;
        return <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@tegwjx`} type={type} onClick={this.onClick} disabled={disabled}>{content}</Button>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/commonComs/buttonNew.tsx